'use strict';

var fileSaver = require('file-saver');
var FileSaveService = function FileSaveService($filter, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function createFile(data, type, fileName) {
    var blob = new Blob([data], {
      type: type
    });
    fileSaver.saveAs(blob, fileName);
  }
  function createFileName(gridId, fileExtension) {
    var dateTime = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    return gridId + '-' + rmMomentFormat(dateTime, 'DATE_TIME_ISO_FILE_NAME') + '.' + fileExtension;
  }
  return {
    createFile: createFile,
    createFileName: createFileName
  };
};
FileSaveService.$inject = ['$filter', 'MomentService'];
module.exports = FileSaveService;